import { createContext } from '@fluentui/react-bindings';
export var ListContext = createContext({
  debug: false,
  selectable: false,
  navigable: false,
  truncateContent: false,
  truncateHeader: false,
  variables: {},
  onItemClick: function onItemClick() {},
  selectedIndex: -1
});
export var ListContextProvider = ListContext.Provider;